import useSecurityQuery from '../../Security/useSecurityQuery';
import { useAppSelector } from '../../core/store';
import { useCallback, useEffect, useMemo } from 'react';
import { UserRoleDto } from '../../../codegen/Swagger';
import useSecurityForModule from '../../Security/useSecurityForModule';
import { useUser } from '../../users';
export enum LicensesMethods {
    View = 'View',
    Manage = 'Manage',
    Delete = 'Delete',
    Approve = 'Approve',
    ManageCod = 'ManageCod',
}

export enum WorkflowStatus {
    New = 'New',
    Modified = 'Modified',
    Approved = 'Approved',
    Rejected = 'Rejected',
}

const useSecurityLantis = () => {
    const securityQuery = useSecurityQuery('Licenses');

    const { hasMethod: rapportenDataHasMethod } = useSecurityForModule('Rapporten');
    const { hasRightForMethod, hasRightForMethodByDataScope } = useSecurityForModule('Licenses');

    const { isLantis, isContractor, isStakeholder } = useUser();

    const roles = useMemo(() => {
        const rolesObj = {} as any;

        (securityQuery.data as UserRoleDto[])?.forEach((e) => {
            const key = e.module?.methods![0].code || '';
            e.module!.methods!.forEach((m) => {
                const scopes = e.userRoleDataScopes?.map((el) => el.valueId) ?? [];
                if (!rolesObj[m.code!]) {
                    rolesObj[m.code!] = scopes;
                } else if (rolesObj[m.code!].length != 0) {
                    scopes.forEach((scope) => {
                        rolesObj[m.code!].push(scope);
                    });
                }
            });
        });
        return rolesObj;
    }, [securityQuery.data]);

    const hasGeneralRights = useCallback(
        (method: LicensesMethods) => {
            return hasRightForMethod(method.toString());
            // if (roles[method]) {
            //     return true;
            // }
            // return false;
            // // if (!roles[method].length) return true;

            // // return false;
        },
        [hasRightForMethod],
    );

    const hasRights = useCallback(
        (method: LicensesMethods, valueId: number, status: WorkflowStatus) => {
            // if (method === LicensesMethodsDB.View && status === WorkflowStatus.Approved) return true;

            if (!roles[method]) return false;

            if (!roles[method].length) return true;

            return roles[method].includes(valueId);
        },
        [roles],
    );

    const getRights = useCallback(
        (valueId: number, status: WorkflowStatus) => {
            const rights = {} as any;
            rights[LicensesMethods.Manage] = hasRightForMethodByDataScope(
                LicensesMethods.Manage.toString(),
                'LicenseCodProject',
                valueId,
            );
            rights[LicensesMethods.View] =
                hasRightForMethod(LicensesMethods.View.toString()) || isLantis ? true : false;

            rights[LicensesMethods.Delete] = hasRightForMethod(LicensesMethods.Delete.toString()) ? true : false;
            rights[LicensesMethods.Approve] = hasRightForMethod(LicensesMethods.Approve.toString()) ? true : false;
            rights[LicensesMethods.ManageCod] = hasRightForMethod(LicensesMethods.ManageCod.toString()) ? true : false;
            return rights;
        },
        [hasRightForMethod, hasRightForMethodByDataScope, isLantis],
    );

    return {
        securityQuery,
        isLantis,
        isContractor,
        isStakeholder,
        hasRights,
        hasGeneralRights,
        getRights,
        rapportenDataHasMethod,
        roles,
    };
};

export default useSecurityLantis;
